import {
  categories_tab,
  menus_tab,
  modifier_groups_tab,
  modifiers_tab,
  products_tab,
} from '../../../../../../views/menu/smart-pricing';
import { SMART_PRICING_RESOURCE_TYPE } from '../../../../../../services/exports/Constants';

export default {
  title: 'Precios inteligentes',
  master_title: 'Modo marca - Precios inteligentes',
  sections: {
    how_it_works: {
      title: 'Cómo funciona',
      description:
        'Los precios inteligentes son una función que te permite controlar tus precios según el método de pedido que usa el cliente. Cubre múltiples casos de uso, como reducir el precio para recogida, aumentarlo para entrega, añadir descuentos en el menú de temporada, etc. Puedes crear reglas en varios niveles (Global, Menú, Categoría, Producto, Grupo de modificadores, Modificador). Los niveles funcionan como un árbol: el nivel superior afecta a los inferiores, pero las reglas de nivel inferior tienen mayor prioridad (p. ej., una regla de 5 % de descuento en recogida para una categoría específica anulará el descuento global del 15 % en recogida para sus productos).',
    },
  },
  tabs: {
    [SMART_PRICING_RESOURCE_TYPE.company]: 'Reglas globales',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: 'Reglas globales',
    [menus_tab]: 'Reglas de menú',
    [categories_tab]: 'Reglas de categoría',
    [products_tab]: 'Reglas de producto',
    [modifier_groups_tab]: 'Reglas de grupo de modificadores',
    [modifiers_tab]: 'Reglas de modificador',
  },
  fields: {
    name: 'Nombre',
    order_methods: 'Métodos de pedido',
    modifier: 'Modificador',
    image: 'Imagen',
    actions: 'Acciones',
  },
  labels: {
    absolute: 'Absoluto',
  },
  buttons: {
    add_rule: 'Añadir regla',
    edit: 'Editar',
    delete: 'Eliminar ({{count}})',
    images: 'Gestionar imagen',
  },
  popups: {
    delete_rule: {
      title: '¿Seguro que desea eliminar?',
    },
  },
  toasts: {
    failed_to_load_data: 'Error al cargar datos',
    failed_to_delete: 'Error al eliminar reglas',
    deleted_successfully: 'Reglas eliminadas correctamente',
  },
};
